var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"oeamtc-input oeamtc-input--date",attrs:{"id":_vm.id,"min":_vm.min,"max":_vm.max,"placeholder":"TT.MM.JJJJ","type":"date"},domProps:{"value":_vm.input},on:{"focus":_vm.handleFocus,"input":_vm.handleInput,"blur":_vm.handleBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }